import { $document, $win } from '../utils/globals'

function gformCols(){
	var col_separate = new Array('.col-separator'),
		cols_value   = col_separate.length,
		i            = 0,
		secondList   = '',
		flag         = true;

	for(i=0;i<cols_value;i++){
		secondList  = $('<div class="gform_fields" />');
		$(col_separate[i]).each(function(){
			flag = true;
			while(flag){
				if($(this).next().is('.gfield') && !$(this).next().hasClass(col_separate[i+1])){
					$(this).next().appendTo(secondList);
				}else{
					flag = false;
				}
			}
		});
		$('.gform_fields').after(secondList);
	}
}

$('.app-block-contact').each(() => {
	$(document).on('gform_post_render', function(event, form_id, current_page){
		if($( ".gform_wrapper" ).hasClass("has-two-columns_wrapper")) {
			gformCols();
		}
 	});

 	$win.on('load', () => {
		const targetForm = $('.app-block-contact .app__block-form');
		
		$(function() {

		  $(targetForm).css( "display", "block" );
		});
	});
});

